import React from 'react';
import { ReactComponent as Logo } from './Assets/svg/logo.svg';
import { withAllContexts } from './AllContextsWrapper';
import { CircularProgress } from '@mui/material';
import { API_URL } from './config';
import { LogIn, Mail, Lock } from 'lucide-react';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      error: null
    };
  }

  handleLogin = (e) => {
    e.preventDefault();
    this.setState({ isLoading: true, error: null });
    
    const email = e.target.email.value;
    const password = e.target.password.value;

    fetch(`${API_URL}login`, {
      method: "POST",
      credentials: 'include',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    })
    .then((res) => res.json())
    .then((data) => {
      if (data.status) {
        this.props.socketIO.socket.disconnect();
        this.props.socketIO.socket.connect();
        this.props.socketIO.socket.emit('get_user_data');
      } else {
        this.setState({ 
          isLoading: false, 
          error: data.error || 'Nesprávne prihlasovacie údaje' 
        });
      }
    })
    .catch(err => {
      this.setState({ isLoading: false, error: 'Chyba pripojenia k serveru' });
    });
  };

  render() {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4 font-sans">
        <div className="w-full max-w-md">
          {/* Card */}
          <div className="bg-white rounded-[2rem] shadow-2xl border border-gray-100 overflow-hidden p-8 md:p-12 animate-fade-in">
            {/* Logo Section */}
            <div className="flex flex-col items-center mb-10">
              <div className="w-32 h-24 mb-6 transition-transform hover:scale-105 duration-500 flex items-center justify-center">
                <Logo className="w-full h-full" />
              </div>
              <h1 className="text-2xl font-black text-gray-900 tracking-tight text-center">
                Kalendár rezervácií
              </h1>
              <p className="text-sm font-bold text-splavma-teal uppercase tracking-[0.2em] mt-2">
                Splavma s.r.o.
              </p>
            </div>

            {/* Error Message */}
            {this.state.error && (
              <div className="bg-red-50 text-red-600 px-4 py-3 rounded-xl text-sm font-bold mb-6 border border-red-100 flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-red-600"></span>
                {this.state.error}
              </div>
            )}

            {/* Form */}
            <form onSubmit={this.handleLogin} className="space-y-5">
              <div className="space-y-1.5">
                <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest ml-1">
                  E-mailová adresa
                </label>
                <div className="relative group">
                  <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-splavma-teal transition-colors">
                    <Mail size={18} />
                  </div>
                  <input
                    required
                    type="email"
                    name="email"
                    autoComplete="email"
                    placeholder="meno@domena.sk"
                    className="w-full pl-12 pr-4 py-4 bg-gray-50 border border-gray-100 rounded-2xl focus:bg-white focus:ring-4 focus:ring-splavma-teal/10 focus:border-splavma-teal transition-all outline-none text-sm font-bold text-gray-900"
                  />
                </div>
              </div>

              <div className="space-y-1.5">
                <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest ml-1">
                  Prihlasovacie heslo
                </label>
                <div className="relative group">
                  <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-splavma-teal transition-colors">
                    <Lock size={18} />
                  </div>
                  <input
                    required
                    type="password"
                    name="password"
                    autoComplete="current-password"
                    placeholder="••••••••"
                    className="w-full pl-12 pr-4 py-4 bg-gray-50 border border-gray-100 rounded-2xl focus:bg-white focus:ring-4 focus:ring-splavma-teal/10 focus:border-splavma-teal transition-all outline-none text-sm font-bold text-gray-900"
                  />
                </div>
              </div>

              <div className="pt-4">
                <button
                  type="submit"
                  disabled={this.state.isLoading}
                  className="w-full bg-splavma-teal hover:bg-[#0a4d47] text-white py-4 rounded-2xl font-black uppercase tracking-widest text-sm transition-all shadow-lg shadow-splavma-teal/20 hover:shadow-xl hover:-translate-y-0.5 active:scale-95 disabled:opacity-70 disabled:pointer-events-none flex items-center justify-center gap-2"
                >
                  {this.state.isLoading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    <>
                      <LogIn size={18} className="mt-0.5" />
                      Prihlásiť sa
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>

          {/* Footer Text */}
          <p className="text-center mt-8 text-gray-400 text-xs font-medium uppercase tracking-widest">
            &copy; {new Date().getFullYear()} Splavma
          </p>
        </div>
      </div>
    );
  }
}

export default withAllContexts(Login);
